// /utils/customers.js

export const createCustomerPayload = (values, country_code, employees, locations, user, existingId = null) => {

  const uploadedFiles = [];
  const existingUrls = [];

  if (Array.isArray(values.document_url)) {
    values.document_url.forEach(file => {
      // ✅ New upload
      if (file.originFileObj instanceof File) {
        uploadedFiles.push(file.originFileObj);
      }

      // ✅ Existing uploaded document (edit mode)
      if (typeof file.url === "string") {
        existingUrls.push(file.url);
      }
    });
  }

  const payload = {
    enableLogin: values.enable_login || false,
    acc_name: values.acc_name?.trim() || "",
    acc_code: values.acc_code || "",
    acc_type: {
      acc_type_name: "Customer",
      acc_type_id: "debitor",
      label: "Customers",
    },
    opening_balance: Number(values.opening_balance || 0),
    institution_name: values.institution_name || "",
    address: values.address || "",
    shipping_address: values.shipping_address || "",
    conversation: values.conversation || "",
    contact_no: values.contact_no || "",
    shipping_contact_no: values.shipping_contact_no || "",
    shipping_contact_person: values.shipping_contact_person || "",
    country_code: country_code || "",
    party_type: values.party_type || "retailer",
    location_id: values.location_id || 0,
    employee_id: values.employee_id || 0,
    credit_limit: values.credit_limit !== undefined &&
      values.credit_limit !== null &&
      values.credit_limit !== ""
      ? Number(values.credit_limit)
      : null,
    email_address: values.email_address || "",
    expectation_per: values.expectation_per || "",
    bank_acc_number: values.bank_acc_number || "",
    bank_acc_name: values.bank_acc_name || "",
    bank_branch: values.bank_branch || "",
    bank_acc_type: values.bank_acc_type || "",
    po_box: values.po_box ? values.po_box.toString() : "",
    shipping_po_box: values.shipping_po_box ? values.shipping_po_box.toString() : "",
    country: values.country || "",
    cus_status: values.cus_status || "active",
    selectedFromAcc: null,
    licence_no: values.licence_no || "",
    licence_validity: values.licence_validity
      ? values.licence_validity.format("YYYY-MM-DD")
      : "",
    vat_no: values.vat_no || "",
    gln_no: values.trn_no || "0",
    gln_validity: values.gln_validity
      ? values.gln_validity.format("YYYY-MM-DD")
      : "",
    company_prefix_length: values.company_prefix_length,
    customer_group_id: values.customer_group_id || 0,
    acc_mgr: values.acc_mgr || "",
    institution_owner: Array.isArray(values.institution_owner) ? values.institution_owner.map(v => v.trim())
      .filter(Boolean).join(",") : "",
    credit_month: Number(values.credit_month || 0),
    document_url: uploadedFiles,
    existing_document: existingUrls.join(","),
    gst_type: values.gst_type,
    province: (values.country == 'India') ? values.state : "",
    hsn_sac_code: values.hsn_sac_code || "",

    is_also_creditor: values.is_also_creditor ? 1 : 0,
    supplier_opening_balance: Number(values.supplier_opening_balance || 0),
    // pass linked_acc_id if editing and already linked
    linked_acc_id: values.linked_acc_id || null,
    default_delivery_route_id: values.default_delivery_route_id || null,
  };

  // 👇 Determine action
  if (existingId) {
    payload.acc_id = existingId;
    payload.action = "update";
  } else {
    payload.acc_id = 0;
    payload.action = "create";
  }

  return payload;
};
